<template>
  <div>
    <b-card class="ps-card">
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <h4 class="m-dirR-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{label.pages.editAndManageInfo}}
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-row>
          <b-col cols="6" clas="py-0">
            <b-row class="my-4 mb-2"  v-show="contentLanguageAccess == 1">
              <b-col cols="3">
                <label for="title" class="ps_label">
                  {{label.pages.contentLanguage}}
                </label>
              </b-col>
              <b-col cols="9">
                <v-select
                      id="language"
                      :options="languages"
                      v-model="selectedLanguage"
                      :reduce="group => group.id"
                      size="sm"
                      class="ps_select"
                      :clearable="false"
                      @input="setLanguage"
                >
                  </v-select>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="title" class="ps_label">
                  {{label.pages.siteTitle}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input id="title" size="sm" v-model="form.title"/>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="tel" class="ps_label">
                  {{label.pages.phoneNumber}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input id="tel" size="sm" v-model="form.tel"/>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="mobile" class="ps_label">
                  {{label.pages.mobileNumber}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input id="mobile" type="number" size="sm" v-model="form.mobile"/>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="receiverNumber" class="ps_label">
                  {{label.pages.receiverNumber}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input id="receiverNumber" type="number" size="sm" v-model="form.receiverNumber"/>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="email" class="ps_label">
                  {{label.pages.email}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input id="email" type="email" size="sm" v-model="form.email"/>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="address" class="ps_label">
                  {{label.pages.workAddress}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-textarea id="address" size="sm" v-model="form.address">
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="my-4 mb-2">
              <b-col cols="3">
                <label for="copyright" class="ps_label">
                  {{label.pages.copyright}}
                </label>
              </b-col>
              <b-col cols="9">
                <b-form-input id="copyright" size="sm" v-model="form.copyright"/>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6" clas="py-0">
            <b-row class="my-5 justify-content-center">
              <b-col cols="5" class="text-center">
                <label for="logo" class="ps_label w-100 mb-2 text-center">
                <b-icon
                    icon="pencil-square"
                    scale="1.2"
                    class="align-middle ms-2"
                />
                {{label.form.mainLogo}}
                <b-icon
                    icon="question-circle-fill"
                    scale="1.2"
                    variant="ps-base"
                    class="me-1 mouse-question"
                    id="mainLogoGuideTlp"
                />
                <b-popover
                  boundary="#app"
                  placement="top"
                  noninteractive
                  triggers="hover"
                  target="mainLogoGuideTlp"
                >
                  {{ label.guide.mainLogo }}
                </b-popover>
              </label>
                <input type="file" ref="logo" id="logo" class="fs10 mt-1" hidden v-on:change="handleFileUpload()"/>
                <img
                    :src="form.logoAddress"
                    class="img-fluid bg-light shadow p-2 rounded mouse-change"
                    alt="logo"
                    @click="clickLogo()"
                />
              </b-col>
              <b-col cols="5" class="text-center">
                <label for="logoSecond" class="ps_label w-100 mb-2 text-center">
                  <b-icon
                      icon="pencil-square"
                      scale="1.2"
                      class="align-middle ms-2"
                  />
                  {{label.form.secondLogo}}
                  <b-icon
                      icon="question-circle-fill"
                      scale="1.2"
                      variant="ps-base"
                      class="me-1 mouse-question"
                      id="secondLogoGuideTlp"
                  />
                  <b-popover
                    boundary="#app"
                    placement="top"
                    noninteractive
                    triggers="hover"
                    target="secondLogoGuideTlp"
                  >
                    {{ label.guide.secondLogo }}
                  </b-popover>
                </label>
                <input type="file" ref="logoSecond" id="logoSecond" class="fs10 mt-1" hidden v-on:change="handleFileUploadSecond()"/>
                <img
                    :src="form.secondLogoAddress"
                    class="img-fluid bg-light shadow p-2 rounded mouse-change"
                    alt="logo"
                    @click="clicklogoSecond()"
                />
              </b-col>
              <b-col cols="5" class="text-center mt-4">
                <label for="favicon" class="ps_label w-100 mb-2 text-center">
                  <b-icon
                      icon="pencil-square"
                      scale="1.2"
                      class="align-middle ms-2"
                  />
                  {{label.form.tinyLogo}}
                  <b-icon
                      icon="question-circle-fill"
                      scale="1.2"
                      variant="ps-base"
                      class="me-1 mouse-question"
                      id="tinyLogoGuideTlp"
                  />
                  <b-popover
                    boundary="#app"
                    placement="top"
                    noninteractive
                    triggers="hover"
                    target="tinyLogoGuideTlp"
                    dir="rtl"
                  >
                    {{ label.guide.tinyLogo }}
                  </b-popover>
                </label>
                <input type="file" ref="favicon" id="favicon" class="fs10 mt-1" accept=".ico" hidden v-on:change="handleFaviconUpload()"/>
                <img
                    :src="form.faviconAddress"
                    class="img-fluid bg-light shadow p-3 rounded mouse-change"
                    alt="logo"
                    @click="clickFavicon()"
                />
              </b-col>
              <b-col cols="5" class="text-center mt-4">
                <label for="thumbnail" class="ps_label w-100 mb-2 text-center">
                  <b-icon
                      icon="pencil-square"
                      scale="1.2"
                      class="align-middle ms-2"
                  />
                  {{label.form.panelLogo}}
                  <b-icon
                      icon="question-circle-fill"
                      scale="1.2"
                      variant="ps-base"
                      class="me-1 mouse-question"
                      id="panelLogoGuideTlp"
                  />
                  <b-popover
                    boundary="#app"
                    placement="top"
                    noninteractive
                    triggers="hover"
                    target="panelLogoGuideTlp"
                  >
                    {{ label.guide.panelLogo }}
                  </b-popover>
                </label>
                <input type="file" ref="thumbnail" id="thumbnail" class="fs10 mt-1" hidden v-on:change="handleThumbUpload()"/>
                <img
                    :src="form.thumbLogoAddress"
                    class="img-fluid bg-light shadow p-3 rounded mouse-change"
                    alt="logo"
                    @click="clickThumbnail()"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
      <template #footer>
        <div class="d-flex justify-content-end">
          <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="$router.go(-1)"
          >
            {{label.buttons.cancel}}
          </b-button>
          <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="editConfig()"
          >
            <b-icon icon="check2-circle" class="ms-1"/>
            {{label.buttons.recordInfo}}
          </b-button>
          <b-button
              v-else
              disabled
              variant="ps-success"
              size="sm"
              class="mx-1"
          >
            <b-spinner small></b-spinner>
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: 'Config',
  mixins: [contentLanguage],
  data() {
    return {
      label,
      logo: null,
      logoSecond: null,
      thumbnail: null,
      favicon: null,
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      form: 'baseX/config',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.reloadData();
      }
    },
  },
  methods: {
    clickLogo() {
      this.$refs.logo.click();
    },
    clicklogoSecond() {
      this.$refs.logoSecond.click();
    },
    clickThumbnail() {
      this.$refs.thumbnail.click();
    },
    clickFavicon() {
      this.$refs.favicon.click();
    },
    handleFileUpload() {
      this.logo = this.$refs.logo.files[0];
    },
    handleFileUploadSecond() {
      this.logoSecond = this.$refs.logoSecond.files[0];
    },
    handleThumbUpload() {
      this.thumbnail = this.$refs.thumbnail.files[0];
    },
    handleFaviconUpload() {
      this.favicon = this.$refs.favicon.files[0];
    },
    editConfig() {
      this.$store.commit("setLoadingBtn", true);
      let formData = new FormData();
      formData.append('languageId', this.selectedLanguage);
      if (this.form.title != null) {
        formData.append('Title', this.form.title);
      }
      if (this.form.tel != null) {
        formData.append('Tel', this.form.tel);
      }
      if (this.form.mobile != null) {
        formData.append('Mobile', this.form.mobile);
      }
      if (this.form.receiverNumber != null) {
        formData.append('ReceiverNumber', this.form.receiverNumber);
      }
      if (this.form.email != null) {
        formData.append('Email', this.form.email);
      }
      if (this.form.address != null) {
        formData.append('Address', this.form.address);
      }
      if (this.form.copyright != null) {
        formData.append('Copyright', this.form.copyright);
      }
      if (this.logo != null) {
        formData.append('Logo', this.logo);
      }
      if (this.logoSecond != null) {
        formData.append('SecondLogo', this.logoSecond);
      }
      if (this.thumbnail != null) {
        formData.append('ThumbLogo', this.thumbnail);
      }
      if (this.favicon != null) {
        formData.append('Favicon', this.favicon);
      }
      const payload = {
        id: this.form.id,
        values: formData
      };
      this.$store.dispatch('baseX/editConfig', payload);
    },
    reloadContent() {
      this.$store.dispatch('baseX/getConfig', this.selectedLanguage);
    },
  },
  mounted() {
    this.reloadContent();
  },

}
</script>
